import { render } from "./Detail.vue?vue&type=template&id=0f7e51f4&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=0f7e51f4&lang=css"
import "./Detail.vue?vue&type=style&index=1&id=0f7e51f4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0f7e51f4"

export default script